import { STATUS } from "./statuses";

/**
 * DEBSUN GENESYS — public platform messaging only.
 * Never reveal architecture, implementation, LLMs, agents,
 * memory, vector databases, or proprietary internals.
 */

export const GENESYS = {
  id: "genesys",
  name: "DEBSUN GENESYS",
  shortName: "GENESYS",
  status: STATUS.UNDER_DEVELOPMENT,
  tagline: "Industrial intelligence initiative",
  hero: {
    eyebrow: "Digital Platforms · Research & Development",
    title: "DEBSUN GENESYS",
    subtitle:
      "Manufacturing is becoming increasingly connected, intelligent and data-driven.",
  },
  problem: {
    title: "The Problem",
    body: [
      "Industrial operations generate more data than most plants can usefully interpret.",
      "Engineering workflows, production systems and operational decision-making often remain fragmented — slowing response, obscuring insight and limiting continuous improvement.",
      "Manufacturers need a coherent way to bring engineering intent and operational reality into one scalable picture.",
    ],
  },
  vision: {
    title: "The Vision",
    body: [
      "DEBSUN GENESYS is our long-term industrial intelligence initiative focused on unifying engineering workflows, industrial operations and intelligent decision support into one scalable platform.",
      "It is being developed as an engineering-grade foundation — not a consumer application, and not a marketing experiment.",
    ],
  },
  industries: [
    "Manufacturing",
    "Process Industries",
    "Steel & Metallurgy",
    "Automotive & Ancillary",
    "Pharma & Chemical",
    "Food & Beverage",
  ],
  futureCapabilities: [
    {
      id: "industrial-intelligence",
      name: "Industrial Intelligence",
      description:
        "Decision support grounded in industrial context and engineering discipline.",
    },
    {
      id: "factory-operations",
      name: "Factory Operations",
      description:
        "Clearer operational visibility across production and plant activities.",
    },
    {
      id: "engineering-collaboration",
      name: "Engineering Collaboration",
      description:
        "Shared workflows that keep engineering and operations aligned.",
    },
    {
      id: "production-analytics",
      name: "Production Analytics",
      description:
        "Structured insight into throughput, quality and operational performance.",
    },
    {
      id: "digital-twin-integration",
      name: "Digital Twin Integration",
      description:
        "Future connection between digital representations and live operations.",
    },
    {
      id: "manufacturing-optimisation",
      name: "Manufacturing Optimisation",
      description:
        "Continuous improvement supported by better operational understanding.",
    },
    {
      id: "ai-assisted-engineering",
      name: "AI-assisted Engineering",
      description:
        "Assistance for engineering tasks within defined industrial boundaries.",
    },
    {
      id: "industrial-data-visualisation",
      name: "Industrial Data Visualisation",
      description:
        "Clear presentation of industrial data for operators and engineers.",
    },
  ],
  futureDirection: {
    title: "Future Direction",
    body: [
      "GENESYS will evolve through careful research, industrial validation and disciplined platform development.",
      "Capabilities will be released only when they meet DEBSUN engineering standards — not before.",
    ],
  },
  currentStatus: {
    title: "Current Status",
    label: STATUS.UNDER_DEVELOPMENT,
    body: [
      "Currently under active research and development.",
      "Public materials describe intent and direction only. Implementation detail remains internal until formally released.",
    ],
  },
  cta: {
    primary: { label: "Contact Engineering", href: "/#contact" },
    secondary: { label: "View Services", href: "/services" },
  },
};

export default GENESYS;
